export const DIVISIONS = {
  transporte: {
    slug: "transporte",
    path: "/transporte",
    index: "01",
    name: "Transporte Disimil",
    tag: "Platinum Sky",
    tagline: "Movilidad Ejecutiva y Corporativa de Confianza.",
    description:
      "Ofrecemos soluciones integrales en el ramo del transporte ejecutivo y traslado de personal. Garantizamos puntualidad, confort y seguridad en cada recorrido, adaptándonos a las necesidades de tu empresa.",
    accent: "#38BDF8",
    hero: "/images/transporte-hero.jpg",
    galleryTitle: "Nuestra Flota e Instalaciones",
    galleryIntro:
      "Unidades ejecutivas de última generación y oficinas operativas listas para atender a tu organización.",
    services: [
      {
        title: "Transporte Ejecutivo",
        desc: "Sedanes y vans de alta gama con conductor profesional para directivos y delegaciones.",
      },
      {
        title: "Traslado de Personal",
        desc: "Rutas corporativas planificadas con monitoreo permanente y cumplimiento de horarios.",
      },
      {
        title: "Unidades Blindadas",
        desc: "Vehículos con blindaje certificado para perfiles que requieren máxima protección.",
      },
      {
        title: "Coordinación 24/7",
        desc: "Centro de control operativo disponible todos los días del año, sin excepciones.",
      },
    ],
    images: [
      {
        url: "/images/mercedes-sedan-real.webp",
        title: "Mercedes-Benz C320 (2010) & Flota Ejecutiva",
        category: "Sedanes Ejecutivos",
      },
      {
        url: "/images/transporte-hero.jpg",
        title: "Van Ejecutiva de Nuestra Flota",
        category: "Vans & Minivans VIP",
      },
      {
        url: "/images/transporte-interior.webp",
        title: "Interior Ejecutivo de Nuestras Unidades",
        category: "Interiores & Confort",
      },
      {
        url: "/images/toyota-4runner.jpg",
        title: "Toyota 4Runner Blindada",
        category: "Vehículos Blindados",
      },
    ],
    cta: "Solicitar Presupuesto",
    trackRecord: {
      kicker: "Trayectoria Comprobada",
      title: "Los grandes escenarios nos conocen.",
      groups: [
        {
          label: "Artistas Internacionales",
          items: ["Luis Miguel", "Marc Anthony", "Phil Collins"],
        },
        {
          label: "Delegaciones Deportivas",
          items: ["Selecciones de todo el continente", "Clubes de élite"],
        },
      ],
    },
    form: {
      buttonTestId: "btn-solicitar-presupuesto-transporte",
      modalTestId: "modal-presupuesto-transporte",
      submitTestId: "btn-submit-transporte-quote",
      title: "Solicitar Presupuesto",
      subtitle: "Cuéntanos los detalles de tu viaje y te enviaremos una propuesta a la medida.",
      fields: [
        { key: "name", label: "Nombre completo", type: "text", required: true, testid: "input-transporte-name" },
        { key: "email", label: "Correo electrónico", type: "email", required: true, testid: "input-transporte-email" },
        { key: "phone", label: "Teléfono", type: "tel", testid: "input-transporte-phone" },
        {
          key: "service",
          label: "Tipo de servicio",
          type: "select",
          options: ["Traslado ejecutivo", "Traslado de personal", "Servicio por horas", "Evento corporativo"],
          testid: "select-transporte-service",
        },
        { key: "details", label: "Detalles del viaje", type: "textarea", required: true, testid: "textarea-transporte-details" },
      ],
    },
  },
  logistica: {
    slug: "logistica",
    path: "/logistica-deportiva",
    index: "02",
    name: "Logística Deportiva Disimil",
    tag: "Kinetic Emerald",
    tagline: "El Motor Detrás de los Grandes Equipos.",
    description:
      "Somos una empresa dedicada a prestar servicios de logística deportiva integral. Atendemos a clubes deportivos y selecciones de diferentes países, gestionando con absoluta precisión todas sus reservaciones hoteleras, boletos aéreos y traslados internos.",
    accent: "#10B981",
    hero: "/images/logistica-hero.jpg",
    galleryTitle: "Operaciones en Movimiento",
    galleryIntro:
      "Cada delegación, cada vuelo y cada traslado coordinado con precisión milimétrica.",
    services: [
      {
        title: "Reservaciones Hoteleras",
        desc: "Gestión completa de alojamiento para clubes y selecciones, con estándares internacionales.",
      },
      {
        title: "Boletos Aéreos",
        desc: "Emisión y coordinación de vuelos comerciales y charter para delegaciones completas.",
      },
      {
        title: "Traslados Internos",
        desc: "Movilidad terrestre sincronizada con itinerarios de entrenamiento y competencia.",
      },
      {
        title: "Coordinación Operativa",
        desc: "Equipo en terreno que acompaña a la delegación durante toda su estancia.",
      },
    ],
    images: [
      {
        url: "/images/logistica-charter.jpg",
        title: "Vuelos Charter y Aviones Exclusivos para Selecciones",
        category: "Transporte Aéreo",
      },
      {
        url: "/images/logistica-equipaje.jpg",
        title: "Manejo de Equipaje y Logística de Utilería Deportiva",
        category: "Aeropuerto & Equipaje",
      },
      {
        url: "/images/logistica-pista.jpg",
        title: "Coordinación Operativa en Pista para Delegaciones",
        category: "Operaciones Especiales",
      },
    ],
    cta: "Planifica tu Logística",
    careSection: {
      kicker: "Rendimiento Total",
      title: "Coordinación, apoyo en menú e hidratación.",
      intro:
        "Cuidamos cada detalle del día a día de la delegación, dentro y fuera del campo, para que el equipo solo se preocupe por competir.",
      image: "/images/logistica-menu.jpg",
      imageCaption: "Alimentación e hidratación de la delegación, servida por nuestro equipo",
      pillars: [
        {
          icon: "clipboard",
          title: "Coordinación Integral",
          desc: "Acompañamiento permanente del staff: itinerarios, entrenamientos y resolución inmediata de cualquier imprevisto.",
        },
        {
          icon: "utensils",
          title: "Apoyo en Menú",
          desc: "Planificación de menús adaptados a las necesidades nutricionales de cada atleta, con proveedores verificados.",
        },
        {
          icon: "droplets",
          title: "Hidratación",
          desc: "Suministro constante de hidratación y suplementación en entrenamientos, partidos y traslados.",
        },
      ],
    },
    clients: {
      kicker: "Han Confiado en Nosotros",
      title: "Clubes y selecciones que mueven el continente.",
      items: [
        { name: "River Plate", country: "Argentina", logo: "/images/logos/river-plate.png" },
        { name: "Boca Juniors", country: "Argentina", logo: "/images/logos/boca-juniors.png" },
        { name: "Flamengo", country: "Brasil", logo: "/images/logos/flamengo.png" },
        { name: "Atlético Mineiro", country: "Brasil", logo: "/images/logos/atletico-mineiro.png" },
        { name: "Independiente del Valle", country: "Ecuador", logo: "/images/logos/independiente-del-valle.png" },
        { name: "Sporting Cristal", country: "Perú", logo: "/images/logos/sporting-cristal.png" },
        { name: "Selección de Colombia", country: "FCF", logo: "/images/logos/colombia-fcf.png" },
        { name: "Selección de Brasil", country: "CBF", logo: "/images/logos/brasil-cbf.png" },
        { name: "Selección de Ecuador", country: "FEF", logo: "/images/logos/ecuador-fef.png" },
        { name: "Selección de Paraguay", country: "APF", logo: "/images/logos/paraguay-apf.png" },
      ],
    },
    trackRecord: {
      kicker: "Trayectoria Comprobada",
      title: "El motor detrás de las figuras más grandes.",
      groups: [
        {
          label: "Figuras del Deporte Mundial",
          items: ["Neymar Jr", "Lionel Messi", "James Rodríguez"],
        },
        {
          label: "Selecciones y Clubes",
          items: ["Selecciones nacionales de todo el continente", "Clubes internacionales"],
        },
      ],
    },
    form: {
      buttonTestId: "btn-planifica-tu-logistica",
      modalTestId: "modal-planifica-logistica",
      submitTestId: "btn-submit-logistica",
      title: "Planifica tu Logística",
      subtitle: "Describe tu delegación y calendario; diseñaremos el operativo completo.",
      fields: [
        { key: "organization", label: "Equipo / Organización", type: "text", required: true, testid: "input-logistica-team" },
        { key: "email", label: "Correo electrónico", type: "email", required: true, testid: "input-logistica-email" },
        { key: "service", label: "Disciplina deportiva", type: "text", testid: "input-logistica-sport" },
        { key: "details", label: "Detalles del operativo", type: "textarea", required: true, testid: "textarea-logistica-details" },
      ],
    },
  },
  protocolo: {
    slug: "protocolo",
    path: "/protocolo",
    index: "03",
    name: "Protocolo Disimil",
    tag: "Imperial Gold",
    tagline: "Discreción, Seguridad y Atención VIP.",
    description:
      "Contamos con una trayectoria comprobada y amplia experiencia en el manejo de grandes figuras deportivas, musicales y misiones diplomáticas en Venezuela. Ofrecemos un servicio de acompañamiento y protocolo que garantiza la tranquilidad y el éxito de cada visita.",
    accent: "#D4AF37",
    hero: "https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    galleryTitle: "Presencia y Resguardo",
    galleryIntro:
      "Acompañamiento discreto para figuras públicas, artistas y misiones diplomáticas.",
    services: [
      {
        title: "Figuras Deportivas",
        desc: "Protocolo integral para atletas de élite: llegadas, agendas, prensa y resguardo.",
      },
      {
        title: "Artistas y Musicales",
        desc: "Manejo de artistas internacionales con coordinación de producción y seguridad.",
      },
      {
        title: "Misiones Diplomáticas",
        desc: "Atención protocolar para delegaciones oficiales y cuerpos diplomáticos.",
      },
      {
        title: "Confidencialidad Garantizada",
        desc: "Acuerdos de confidencialidad y procedimientos de discreción en cada operación.",
      },
    ],
    images: [
      {
        url: "https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "Acompañamiento VIP para Dignatarios y Artistas",
        category: "Seguridad VIP",
      },
      {
        url: "https://images.unsplash.com/photo-1760228604788-db8a36d5c1a3?crop=entropy&cs=srgb&fm=jpg&q=85",
        title: "Escolta y Protocolo Diplomático en Eventos",
        category: "Misiones Diplomáticas",
      },
      {
        url: "https://images.pexels.com/photos/38809997/pexels-photo-38809997.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "Protocolo de Estado y Resguardo de Alto Nivel",
        category: "Resguardo Estratégico",
      },
    ],
    cta: "Contactar Asesoría Confidencial",
    form: {
      buttonTestId: "btn-contactar-asesoria-confidencial",
      modalTestId: "modal-asesoria-confidencial",
      submitTestId: "btn-submit-protocolo",
      title: "Asesoría Confidencial",
      subtitle: "Tu información se maneja bajo estrictos acuerdos de confidencialidad.",
      fields: [
        { key: "organization", label: "Entidad / Organización", type: "text", required: true, testid: "input-protocolo-entity" },
        { key: "email", label: "Correo electrónico", type: "email", required: true, testid: "input-protocolo-email" },
        {
          key: "service",
          label: "Tipo de misión",
          type: "select",
          options: ["Figura deportiva", "Artista / Musical", "Misión diplomática", "Otro"],
          testid: "select-protocolo-level",
        },
        { key: "details", label: "Detalles de la visita", type: "textarea", required: true, testid: "textarea-protocolo-details" },
      ],
    },
  },
  garaje: {
    slug: "garaje",
    path: "/ciudad-garaje",
    index: "04",
    name: "Ciudad Garaje",
    tag: "Copper Amber",
    tagline: "Cervecería Artesanal de Alto Nivel.",
    description:
      "Descubre nuestro restaurante y cervecería artesanal, un espacio diseñado para disfrutar de la mejor gastronomía y un ambiente inigualable.",
    accent: "#F97316",
    hero: "/images/garaje-hero.jpg",
    externalUrl: "https://www.ciudad-garaje.com",
    images: [
      {
        url: "/images/garaje-barra.jpg",
        title: "Nuestra barra: tiradores y copas listas para servir",
        category: "Barra & Cerveza de Barril",
      },
      {
        url: "/images/garaje-cervezas.jpg",
        title: "Las tres casas de Garaje: Dorada, Roja y Negra — pide por WhatsApp",
        category: "Cerveza Artesanal Garaje",
      },
      {
        url: "/images/garaje-terraza.jpg",
        title: "Noches de terraza con un ambiente inigualable en Caracas",
        category: "Experiencia Garaje",
      },
    ],
  },
};

export const DIVISION_LIST = [
  DIVISIONS.transporte,
  DIVISIONS.logistica,
  DIVISIONS.protocolo,
  DIVISIONS.garaje,
];
